import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { useSEO } from "@/hooks/useSEO";
import { PageHero } from "@/components/shared/PageHero";
import { SectionRenderer } from "@/components/shared/SectionRenderer";
import { PageCta } from "@/components/shared/PageCta";

export const StaticPage = ({ pageKey, path, seoTitle, seoDescription, ctaVariant = "both", showCta = true }) => {
  const { t } = useI18n();
  const p = t(`pages.${pageKey}`);
  useSEO({ title: seoTitle || p.title, description: seoDescription || p.lead, path });

  return (
    <>
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} />
      <SectionRenderer sections={p.sections || []} />
      {showCta && <PageCta variant={ctaVariant} />}
    </>
  );
};
